<script setup lang="ts">
import { UITag } from '@groover-dev/groover-ui'

import type { ChartsTrackStatus } from '~/types/ChartsTrackStatus'

type Props = {
  darkenBg?: boolean
  hideText?: boolean
  status?: ChartsTrackStatus
}

const props = withDefaults(defineProps<Props>(), {
  darkenBg: false,
  hideText: false,
  status: 'active',
})

const { t } = useI18n()

const chartsText = computed(() =>
  props.status === 'pending'
    ? t('charts.status.pending')
    : t('charts.featureName'),
)

const color = computed(() => {
  return props.status === 'active' ? 'primary' : 'default'
})
</script>

<template>
  <UITag
    :color
    icon-left-name="groover:charts"
    :text="hideText ? undefined : chartsText"
    :class="{
      '!tw-bg-fill-primary-discrete': darkenBg && status === 'active',
      '!tw-bg-fill-discrete2':
        darkenBg && ['pending', 'fallen-off'].includes(status),
    }"
    class="tw-overflow-hidden"
    :aria-label="hideText ? chartsText : undefined"
  />
</template>

<style scoped>
:deep(.tw-text-discrete) {
  @apply tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap;
}
</style>
